import React from 'react';
import { oneOf, string, bool } from 'prop-types';
import IconLayout from 'components/IconLayout';
import IconTrend from 'icons/trend.inline.svg';

import styles from './speed-trend-icon.scss';

export default function SpeedTrendIcon({ trend, className, alignMiddle }) {
  return (
    <IconLayout className={className} alignMiddle={alignMiddle}>
      <IconTrend className={trend === 'up' ? styles.up : styles.down} />
    </IconLayout>
  );
}

SpeedTrendIcon.propTypes = {
  trend: oneOf(['up', 'down']).isRequired,
  className: string,
  alignMiddle: bool,
};



// WEBPACK FOOTER //
// ./src/components/SpeedTrendIcon/index.js